export default __webpack_public_path__ + "static/media/Deskera-Tally-Integration.671d2ea9.tcp";